/**
 * OnboardingStep1.tsx - Academic Interests
 * Academic interests step of the onboarding flow.
 * Allows users to select academic areas they're interested in (multi-select).
 */
import React from "react";
import { View } from "react-native";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import CareerInterestsEditor from "../preferences/editors/CareerInterestsEditor";
import { spacingStyles } from "../../../styles/design-system";

export interface OnboardingStep1Props {
  selectedCareerPaths: string[];
  onCareerPathsChange: (paths: string[]) => void;
}

function OnboardingStep1({ selectedCareerPaths, onCareerPathsChange }: OnboardingStep1Props) {
  return (
    <View style={spacingStyles.mNone}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step1_title"
        subtitleKey="companion_onboarding_step1_subtitle"
      />
      <CareerInterestsEditor value={selectedCareerPaths} onChange={onCareerPathsChange} />
    </View>
  );
}

export default OnboardingStep1;
